/* @flow */

/**
 * Gets the count of projects, assets etc and allows
 * for the item being counted to bea number of object
 */
export function getCountForTables(c: any): number {
  let result: number = 0;

  if (typeof c === 'number' || typeof c === 'string') {
    result = c;
  } else if (typeof c === 'object') {
    if (c.length) {
      result = c[0].count;
    } else {
      return c.count || 0;
    }
  }

  return result;
}
